export const de = {
  // Nav
  "Notifications": "Benachrichtigungen",
  "More": "Mehr",
  "Logout": "Abmelden",
  "NoNotifications": "Keine Benachrichtigungen",
  // Mobile Timesheets
  "WeekTotal": "Wochensumme",
  "entries": "Einträge",
  "Weekend": "Wochenende",
  "AddEntry": "Eintrag hinzufügen",
  "SendForApproval": "Zur Genehmigung senden",
  "NoEntriesDay": "Keine Einträge für diesen Tag",
  "EditEntry": "Eintrag bearbeiten",
  "NewEntry": "Neuer Eintrag",
  "CategoryTask": "Kategorie & Aufgabe",
  "WhatDidYouDo": "Was hast du gemacht…",
  "Draft": "Entwurf",
  "Fulfilled": "Genehmigt",
  "Rejected": "Abgelehnt",
  "SelectTask": "Aufgabe auswählen",
  "EnterTime": "Start- und Endzeit eingeben",
  "EndAfterStart": "Endzeit muss nach Startzeit liegen",
  "EntryUpdated": "Eintrag aktualisiert",
  "EntryAdded": "Eintrag hinzugefügt",
  "SaveError": "Fehler beim Speichern",
  "ConfirmDelete": "Diesen Eintrag löschen?",
  "DeleteError": "Fehler beim Löschen",
  "SentForApproval": "Zur Genehmigung gesendet",
  "WeekReturned": "Woche als Entwurf zurückgesetzt",
  "SendWeekTitle": "Woche zur Genehmigung senden?",
  "SendWeekWarning": "Die gesamte Woche wird zur Genehmigung an Ihren Vorgesetzten gesendet. Sie können die Einträge erst nach der Prüfung wieder bearbeiten.",
  "hShort": "Std",
  "mShort": "Min",
  // Mobile Dashboard
  "Hi": "Hallo",
  "Worked": "Gearbeitet",
  "OnApproval": "Zur Genehmigung",
  "TOILBalance": "TOIL-Saldo",
  "News": "Neuigkeiten",
  "NoNews": "Keine Neuigkeiten",
  // Mobile Equipment
  "PATtest": "PAT-Prüfung",
  "Capitalised": "Aktiviert",
  "Warranty": "Garantie",
  "Notes": "Notizen",
  "NoEquipment": "Keine Geräte",
  // Mobile Documents
  "OpenDocument": "Dokument öffnen",
  "Acknowledge": "Bestätigen",
  "NoDocuments": "Keine Dokumente",
  "Type": "Typ",
  "Added": "Hinzugefügt",
  // Mobile sections (Finance/HR/CRM/Training/Booking/Tasks/Community)
  "OnHold": "Pausiert",
  "Completed": "Abgeschlossen",
  "Archived": "Archiviert",
  "NoData": "Nichts gefunden",
  "Approved": "Genehmigt",
  "Paid": "Bezahlt",
  "NoExpenses": "Keine Ausgaben",
  "AbsentToday": "Heute abwesend",
  "Employees": "Mitarbeiter",
  "InProgress": "In Bearbeitung",
  "NotStarted": "Nicht begonnen",
  "NoCourses": "Keine Kurse",
  "Pages": "Seiten",
  "Questions": "Fragen",
  "PassThreshold": "Bestehensgrenze",
  "Score": "Ergebnis",
  "My": "Meine",
  "Rooms": "Räume",
  "Seats": "Plätze",
  "NoBookings": "Keine Buchungen",
  "Done": "Erledigt",
  "High": "Hoch",
  "Medium": "Mittel",
  "Low": "Niedrig",
  "NoTasks": "Keine Aufgaben",
  "Due": "Fällig",
  "Rental": "Vermietung",
  "NoEntriesWeek": "Keine Einträge diese Woche",
  "Timesheets": "Stundenzettel",
  "Reports": "Berichte",
  "Approve": "Genehmigen",
  "Approvals": "Genehmigungen",
  "Clients": "Kunden",
  "Equipment": "Ausrüstung",
  "Booking": "Buchung",
  "Expenses": "Ausgaben",
  "Orders": "Aufträge",
  "Admin": "Admin",
  "Users": "Benutzer",
  "Toil": "Freizeitausgleich",
  "UsersReports": "Benutzerberichte",
  // Header menu
  "Setting": "Einstellungen",
  "Profile": "Profil",
  "LogOut": "Abmelden",
  "RailSummary": "Intelligente Zusammenfassung",
  "RailSchedule": "Zeitplan",
  "RailManage": "Verwaltungsbereich",
  "Login": "Anmelden",
  "Search": "Suchen...",
  "Filter": "Filter",
  "AddFilter": "Filter hinzufügen",
  "SearchOrFilter": "Suchen oder filtern…",
  "Remove": "Entfernen",
  "Notification": "Benachrichtigungen",
  // Report table
  "Date": "Datum",
  "StartTime": "Startzeit",
  "EndTime": "Endzeit",
  "Category": "Kategorie",
  "CategoryNew": "Kategorie ★",
  "Task": "Aufgabe",
  "Description": "Beschreibung",
  "Supervisor": "Vorgesetzter",
  "Hours": "Stunden",
  "Edit": "Bearbeiten",
  "Download": "Herunterladen",
  "AreYouSureDownload": "Möchten Sie diesen Bericht wirklich herunterladen?",
  "ReportList": "Berichtsliste",
  // Approve Table
  "TotalUserHours": "Gesamtstunden des Benutzers",
  "TotalCategoryHours": "Gesamtstunden der Kategorie",
  "Name": "Name",
  "Total": "Gesamt",
  "ApproveAll": "Alle genehmigen",
  "Return": "Zurückgeben",
  "ApproveAllForWeek": "Woche genehmigen",
  "TotalWeek": "Gesamtstunden der Woche",
  "RemoveAllForWeek": "Woche zurückgeben",
  "AreYouSureBack": "Möchten Sie wirklich die gesamte Woche zurückgeben?",
  "RejectMessage": "Bitte geben Sie einen Grund für die Rückgabe an",
  "ApproveList": "Genehmigungsliste",
  // Timesheets
  "AreYouSureReport": "Möchten Sie wirklich einen Wochenbericht einreichen?",
  "Add": "Hinzufügen",
  "SendTo": "Zur Genehmigung senden",
  "SelectUsers": "Benutzer auswählen",
  "ReturnWeek": "Woche zurückgeben",
  "ResubmitRejected": "Abgelehnte erneut senden",
  "SelectTemplate": "Vorlage auswählen",
  "PerWee": "Pro Woche",
  "TOIL": "TOIL",
  "TimesheetsList": "Stundenzettelliste",
  "AddReport": "Bericht hinzufügen",
  "CreateWeekTemplate": "Vorlage erstellen",
  "ThisWeek": "Diese Woche",
  "ChooseUser": "Benutzer auswählen",
  "SelectCategory": "Kategorie auswählen...",
  "DescriptionPoins": "Beschreibung...",
  "AreYouSureBackWeek": "Möchten Sie diese Woche wirklich zurückgeben?",
  // Expenses
  "AreYouSureChangeStatus": "Möchten Sie wirklich ändern",
  "AccountNumber": "Kontonummer",
  "FinanceAdditionalInfo": "Zusätzliche Finanzinformationen:",
  "Visible fields": "Sichtbare Felder",
  "Hidden fields": "Versteckte Felder",
  "StatusExp": "Status",
  "to": "zu",
  "StatusExpense": "Status",
  "AddExpenses": "Ausgaben hinzufügen",
  "CreateExpenseClaim": "Neuen Ausgabenantrag erstellen",
  "AddIncomeSub": "Neuen Einkommenseintrag erfassen",
  "AddCarExpenseSub": "Neue Fahrt- / Autoausgabe erfassen",
  "NameCreator": "Ersteller",
  "Staff": "Personal",
  "Amount": "Betrag",
  "Phone": "Telefon",
  "AddUserInfo": "Benutzerinformationen hinzufügen",
  "Project": "Projekt",
  "ExensesList": "Ausgabenliste",
  "ExpensesList": "Ausgabenliste",
  "Period": "Zeitraum",
  "Time": "Zeit",
  "BrowsePaymant": "Zahlung hochladen",
  "BrowsePayment": "Zahlung hochladen",
  "Payment": "Zahlung",
  "Car": "Auto",
  "Cars": "Autos",
  "Distance": "Entfernung",
  "Purpose": "Zweck",
  "AddCarExpenses": "Autoausgaben hinzufügen",
  "AdditionalInfo": "Zusätzliche Informationen",
  "Brand": "Marke",
  "PlateNumber": "Kennzeichen",
  "Year": "Jahr",
  "Mileage": "Kilometerstand",
  "Doc": "Dokument",
  "FuelType": "Kraftstofftyp",
  "AvgFuelConsumption": "Durchschnittlicher Kraftstoffverbrauch",
  "CostPerKm": "Kosten pro",
  "Vin": "FIN",
  "InsuranceProvider": "Versicherungsanbieter",
  "InsuranceExpiryDate": "Ablaufdatum der Versicherung",
  "InsurancePolicyNumber": "Versicherungspolice-Nummer",
  "BrowseInsurance": "Versicherung hochladen",
  "UsageType": "Nutzungsart",
  "EditCars": "Autos bearbeiten",
  "CarsInfo": "Fahrzeuginformationen",
  "Active": "Aktiv",
  "AddCars": "Auto hinzufügen",
  "Destination": "Ziel",
  "ExensesCarsList": "Autoausgabenliste",
  "CarExpensesList": "Autoausgabenliste",
  "EstimatedCost": "Geschätzte Kosten",
  "StaffToggleHint": "Deaktivieren, um Bankdaten des Zahlungsempfängers hinzuzufügen",
  "NoExpensesAvailable": "Keine Ausgaben für den ausgewählten Zeitraum gefunden",
  "NoCarExpensesAvailable": "Keine Autoausgaben für den ausgewählten Zeitraum gefunden",
  "FillRequiredFields": "Pflichtfelder ausfüllen",
  "ChooseAmount": "Betrag wählen",
  "AmountInvalidEnd": "Betrag darf nicht mit einem Punkt oder Komma enden",
  "UploadFileRequired": "Bitte laden Sie ein Zahlungsdokument hoch",
  "FileSizeLimit": "Dateigröße muss weniger als 2 MB betragen",
  "ChooseCategory": "Kategorie wählen",
  "ChooseCars": "Auto wählen",
  "StartingPointRequired": "Startpunkt ist erforderlich",
  "DestinationRequired": "Ziel ist erforderlich",
  "PurposeRequired": "Zweck ist erforderlich",
  "DistanceRequired": "Entfernung muss größer als 0 sein",
  "RejectionReason": "Ablehnungsgrund",
  "RejectionReasonPlaceholder": "Bitte geben Sie einen Grund für die Ablehnung an...",
  "Confirm": "Bestätigen",
  "LicenseExpired": "Führerschein ist abgelaufen",
  "LicenseExpiringSoon": "Führerschein läuft bald ab",
  "InsuranceInfo": "Versicherungsinfos",
  "CostCar": "Fahrzeugkosten",
  "OtherInfo": "Sonstige Informationen",
  "MOTInfo": "HU-Informationen",
  "MotExpiryDate": "HU-Ablaufdatum",
  "BrowseMot": "HU hochladen",
  // Equipment
  "Import": "Importieren",
  "AreYouSureEquipment": "Möchten Sie dieses Muster wirklich herunterladen?",
  "AreYouSureEquipmentAll": "Möchten Sie die ausgewählten Geräte wirklich herunterladen?",
  "AddEqp": "Gerät hinzufügen",
  "EqpList": "Geräteliste",
  "InventoryList": "Inventarliste",
  "PatTestList": "PAT-Test-Liste",
  "Number": "Nummer",
  "Item": "Artikel",
  "Items": "Einträge",
  "Manufacturer": "Hersteller",
  "Model": "Modell",
  "SerialNumber": "Seriennummer",
  "Responsive": "Verantwortlich",
  "PurchaseDate": "Kaufdatum",
  "Cost": "Kaufpreis",
  "PATTestDate": "PAT-Test-Datum",
  "PATTestDue": "PAT-Test fällig",
  "PATTestUser": "PAT-Test-Benutzer",
  "Note": "Notiz",
  "ResponsibleForItem": "Verantwortlich für Artikel:",
  "WarrantyDue": "Garantie fällig",
  "ItemInfo": "Artikelinformationen",
  "PATInfo": "PAT-Informationen",
  "ResponsibleForPAT": "Verantwortlich für PAT",
  "EditEquipment": "Gerät bearbeiten",
  "Eqp": "Ausrüstung",
  "RentalOpportunity": "Vermietungsmöglichkeit",
  "InventoryID": "Inventar-ID",
  "EditEqp": "Gerät bearbeiten",
  "InventoryDate": "Inventardatum",
  "InventoryUser": "Inventarbenutzer",
  "InventoryInfo": "Inventarinformationen",
  "SelectTheNumberOfMonths": "Anzahl der Monate auswählen",
  "Selected": "ausgewählt",
  "SelectAll": "Alle auswählen",
  // Template
  "Template": "Vorlage",
  "Temp": "Vorlage",
  "CreateNew": "Neu erstellen",
  "MyTemplates": "Meine Vorlagen",
  "EditTemp": "Vorlage bearbeiten",
  "To": "bis",
  "Empty": "Leer",
  "NoAccess": "Kein Zugriff",
  "StatusUpdateFailed": "Status konnte nicht geändert werden. Bitte erneut versuchen",
  "NoAccessHint": "Ihre Rolle erlaubt diesen Bereich nicht. Wenden Sie sich an Ihren Administrator",
  "AddTempate": "Eintrag hinzufügen",
  "CreateWeekTempate": "Vorlage aus dieser Woche erstellen",
  "AddNewTemplate": "Neue Vorlage hinzufügen",
  "Tempate": "Vorlage",
  "мaximum20characters": "Maximal 20 Zeichen",
  "AddTo": "Hinzufügen zu",
  "InsertTemp": "Diese Vorlage in den Bericht einfügen?",
  // Docs
  "AddDocs": "Dokument hinzufügen",
  "AddDocument": "Dokument hinzufügen",
  "EditDocument": "Dokument bearbeiten",
  "CreateDoc": "Dokument erstellen",
  "UploadFile": "Datei hochladen",
  "HowAddDoc": "Wie möchten Sie das Dokument hinzufügen?",
  "OpenEditorHint": "Editor öffnen und Dokument schreiben",
  "UploadFileHint": "PDF · bis 1 MB",
  "CreateOrUploadHint": "Erstellen oder laden Sie ein Dokument hoch und wählen Sie, wer es bestätigen muss",
  "CreateOrUpload": "Erstellen Sie ein Dokument oder laden Sie eine Datei hoch",
  "EmptyDocument": "Das Dokument ist leer",
  "OnlyPdf": "Nur PDF",
  "StartWriting": "Beginnen Sie zu schreiben…",
  "NewDocument": "Neues Dokument",
  "NoDocumentSelected": "Kein Dokument ausgewählt",
  "EditorDraft": "Editor · Entwurf",
  "CurrentFile": "Aktuelle Datei",
  "ReplaceFile": "Ersetzen",
  "OpenToReadSign": "Doppelklick zum Lesen & Signieren",
  "Text": "Text",
  "select": "auswählen",
  "Title": "Titel",
  "Discription": "Beschreibung",
  "Info": "Info",
  "ViewDoc": "Ansehen",
  "Informed": "Informiert",
  "AddFile": "Datei hinzufügen",
  "AllUsers": "Alle Benutzer",
  "ChooseUsers": "Benutzer auswählen",
  "DayLearn": "Überprüfungsfrist",
  "Review": "Akzeptieren",
  "StatusDoc": "Status",
  "CategoryList": "Kategorieliste",
  "DoYouReallyWantToReviewThisDocument": "Ich habe den Inhalt der Richtlinie gelesen, verstanden und stimme zu",
  "DoYouReallyWantToDeleteThisDocument?": "Möchten Sie dieses Dokument wirklich löschen?",
  // Docs — Variant 5 grid
  "Filters": "Filter",
  "FileType": "Dateityp",
  "AllStatuses": "Alle Status",
  "PolicyStatusNotAssigned": "Nicht zugewiesen",
  "PolicyStatusPending": "Ausstehend",
  "PolicyStatusAcknowledged": "Bestätigt",
  "PolicyBtnAcknowledge": "Bestätigen",
  "CardsView": "Karten",
  "SignedOff": "Bestätigung",
  "Signed": "Bestätigt",
  "Pending": "Ausstehend",
  "Deadline": "Frist",
  "ClearAll": "Alle löschen",
  "AllCategories": "Alle Kategorien",
  "Days": "Tg.",
  // Booking
  "BookingCalendar": "Buchungskalender",
  "NoBookingsAvailable": "Keine Buchungen verfügbar",
  "CalendarView": "Kalender",
  "ListView": "Liste",
  "AddBooking": "Buchung hinzufügen",
  "EditBooking": "Buchung bearbeiten",
  "DeleteBooking": "Buchung löschen",
  "BookedFor": "Gebucht für",
  "PrevMonth": "Vorheriger Monat",
  "NextMonth": "Nächster Monat",
  "AllResources": "Alle",
  "EquipmentOnly": "Geräte",
  "RoomsOnly": "Räume",
  "SearchResources": "Geräte / Räume suchen...",
  "FilterByType": "Typ",
  "FilterByUser": "Gebucht für",
  "ResetFilters": "Zurücksetzen",
  "BookingOverlapError": "Diese Ressource ist für den gewählten Zeitraum bereits gebucht",
  "ResourceType": "Ressourcentyp",
  "SelectEquipment": "Gerät auswählen",
  "SelectRoom": "Raum auswählen",
  "BookingNotes": "Notizen (optional)",
  "ManageRooms": "Räume",
  "AddRoom": "Raum hinzufügen",
  "EditRoom": "Raum bearbeiten",
  "DeleteRoom": "Raum löschen",
  "RoomName": "Raumname",
  "RoomLocation": "Standort / Etage",
  "RoomDescription": "Beschreibung",
  "ConfirmDeleteBooking": "Diese Buchung löschen?",
  "ConfirmDeleteRoom": "Diesen Raum löschen?",
  "BookingResource": "Ressource",
  // Reports
  "SortBy": "Sortieren nach",
  "User": "Benutzer",
  "StatusReport": "Status",
  "Export": "Exportieren",
  "AddFilters": "Filter hinzufügen",
  // Users
  "Email": "E-Mail",
  "Role": "Rolle",
  "users": "Benutzer",
  "UsersList": "Benutzerliste",
  "AddUser": "Benutzer hinzufügen",
  "fillter": "filtern...",
  "EditUser": "Benutzer bearbeiten",
  "PersonalInformation": "Persönliche Informationen",
  "LastName": "Nachname",
  "SecondName": "Zweiter Name",
  "DateOfBirth": "Geburtsdatum",
  "Sex": "Geschlecht",
  "WorkInformation": "Arbeitsinformationen",
  "JobTitle": "Berufsbezeichnung",
  "ContractStartDate": "Vertragsbeginn",
  "Department": "Abteilung",
  "ContractType": "Vertragsart",
  "ContractedHoursPerWeek": "Vertraglich vereinbarte Stunden pro Woche",
  "MinLeaveEntitlement": "Min. Urlaubsanspruch",
  "ContactInformation": "Kontaktinformationen",
  "MobilePhone": "Mobiltelefon",
  "WorkPhone": "Arbeitstelefon",
  "Postcode": "Postleitzahl",
  "City": "Stadt",
  "Address": "Adresse",
  "OtherSettings": "Weitere Einstellungen",
  "TimeZone": "Zeitzone",
  "NotificationLanguage": "Benachrichtigungssprache",
  "ChangePassword": "Passwort ändern",
  "SavedSuccessfully": "Erfolgreich gespeichert",
  "PhotoUpdated": "Foto aktualisiert",
  "PhotoTooLarge": "Datei muss kleiner als 5 MB sein",
  "PhotoUploadError": "Upload-Fehler",
  "PasswordChanged": "Passwort geändert",
  "PasswordsDoNotMatch": "Passwörter stimmen nicht überein",
  "EnterPassword": "Bitte Passwort eingeben",
  "ErrorSaving": "Fehler beim Speichern",
  "RegisterUser": "Benutzer registrieren",
  "RegistrationInformation": "Registrierungsinformationen",
  "Password": "Passwort",
  "LastLogin": "Letzte Anmeldung",
  "View": "Ansicht",
  "ConfirmPassword": "Passwort bestätigen",
  "FirstName": "Vorname",
  "AreYouUser": "Möchten Sie diesen Benutzer wirklich löschen?",
  "DriverLicense": "Führerschein",
  "LicenseExpiryDate": "Ablaufdatum des Führerscheins",
  "DriverLicenseInfo": "Führerscheininformationen",
  "BrowseLicense": "Führerschein hochladen",
  "LicenseNumber": "Führerscheinnummer",
  "VehicleClass": "Fahrzeugklasse",
  "IssueDate": "Ausstellungsdatum",
  "PhotoFront": "Foto (Vorderseite)",
  "PhotoBack": "Foto (Rückseite)",
  "SaveLicense": "Führerschein speichern",
  "ClickToUpload": "Zum Hochladen klicken",
  // Settings
  "CompanyInfo": "Unternehmensinformationen",
  "CompanyName": "Unternehmensname",
  "EditPanel": "Panel bearbeiten",
  "Settings": "Einstellungen",
  "AddCategory": "Kategorie hinzufügen",
  "AddChildCategoryFor": "Unterkategorie hinzufügen für",
  "SelectSupervisor": "Vorgesetzten auswählen",
  "AddParentCategory": "Übergeordnete Kategorie hinzufügen",
  "ChangeNameCategory": "Kategorienamen ändern",
  "ChangeParents": "Übergeordnete Kategorie ändern",
  "AreYouSure": "Möchten Sie dies wirklich löschen",
  "Sourc": "Quelle",
  "LegalEntityType": "Art der juristischen Person",
  "LegalEntity": "Juristische Person",
  "LegalEntityFix": "Juristische Person",
  "Sour": "Quelle",
  "Cat": "Kategorie",
  "Cont": "Vertrag",
  "Dep": "Abteilung",
  "DepT": "Abteilung",
  "Loc": "Standort",
  "Stat": "Status",
  "Equ": "Gerätekategorie",
  "CatEqu": "Gerätekategorie",
  "CatEqupm": "Gerätekategorie",
  "Tasks": "Aufgabe",
  "ChangeName": "Name ändern",
  "AddRole": "Rolle hinzufügen",
  "AddTasks": "Aufgaben hinzufügen",
  "EnterNameOf": "Name eingeben von",
  "EditRole": "Rolle bearbeiten",
  "RoleName": "Rollenname",
  "ColorRole": "Rollenfarbe",
  "RoleAccess": "Rollenzugriff",
  "Delete": "Löschen",
  "ShowAll": "Alle anzeigen",
  "AddEdit": "Hinzufügen/Bearbeiten",
  "AreYouSureRole": "Möchten Sie diese Rolle wirklich löschen?",
  "Create": "Erstellen",
  "Location": "Standort",
  "Status": "Status",
  "Contract": "Vertrag",
  "TasksType": "Aufgabe",
  "CreateRole": "Rolle erstellen",
  "Roles": "Rollen",
  "Availability": "Verfügbarkeit",
  "CreateEdit": "Erstellen/Bearbeiten",
  "EnterNameOfRole": "Rollennamen eingeben",
  "ChangeColor": "Farbe ändern",
  "EditTitle": "Titel bearbeiten",
  "DeleteRole": "Rolle löschen",
  // Finance
  "SalaryPerHours": "Gehalt pro Stunde",
  "AddNewSalary": "Neues Gehalt hinzufügen",
  "DateNewSalary": "Datum des neuen Gehalts",
  "StartDate": "Startdatum",
  "CostPerHour": "Kosten pro Stunde",
  "PerWeek": "Pro Woche",
  "History": "Verlauf",
  "EndDate": "Enddatum",
  "RemoveAll": "Alle entfernen",
  "Information": "Informationen",
  "empty": "leer",
  // TOIL
  "TotalTOIL": "Gesamt-TOIL",
  "AddToils": "TOIL hinzufügen",
  "AddInformation": "Informationen hinzufügen",
  "CreatingDate": "Erstellungsdatum",
  "TotalHours": "Gesamtstunden",
  "OursPerWeek": "Stunden pro Woche",
  "Source": "Quelle",
  "removeTOIL": "TOIL-Korrektur",
  "discriptions": "Beschreibungen",
  "Refresh": "Aktualisieren",
  // Tasks
  "AllTasks": "Alle Aufgaben",
  "SelectTasksPoins": "Aufgaben auswählen...",
  // Edit Reports
  "EditReports": "Berichte bearbeiten",
  "EditDate": "Datum bearbeiten",
  "EditCategory": "Kategorie bearbeiten",
  "SelectTasks": "Aufgaben auswählen",
  "EditDescription": "Beschreibung bearbeiten",
  // Delete modal
  "AreYouReport": "Möchten Sie diese Berichte wirklich löschen?",
  "AreYouReportCat": "Möchten Sie diese Kategorie wirklich löschen?",
  "AreYouReportCatModal": "Möchten Sie diese Kategorie wirklich löschen",
  // All button
  "Yes": "Ja",
  "No": "Nein",
  "Cancel": "Abbrechen",
  "Change": "Ändern",
  "Register": "Registrieren",
  "Close": "Schließen",
  // Other
  "underDevelopment": "Entschuldigung, dieser Bereich befindet sich derzeit in der Entwicklung",
  "ReturnToHome": "Zur Startseite",
  "LoginLog": "Anmelden",
  "SignIn": "Anmelden",
  "SignUp": "Registrieren",
  "SelectCountry": "Land auswählen",
  "CreateAccount": "Konto erstellen",
  "CreateAccountSub": "Verwalten Sie Ihr Team mit TimeBerlo in wenigen Minuten.",
  "AuthHeroTitle": "Der smartere Weg,",
  "AuthHeroAccent": "Ihr Team zu verwalten",
  "AuthHeroSub": "Zeiterfassung, Genehmigungen, Ausgaben, HR-Dokumente und CRM — alles an einem Ort.",
  "TrustSsl": "256-Bit-SSL",
  "TrustGdpr": "DSGVO-konform",
  "AllFieldsRequired": "Alle Felder sind erforderlich",
  "InvalidEmailFormat": "Ungültiges E-Mail-Format",
  "RegistrationFailed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "RegistrationSuccess": "Registrierung erfolgreich",
  "VerifyEmailTitle": "Posteingang prüfen",
  "VerifyEmailSentTo": "Wir haben einen Bestätigungslink gesendet an",
  "VerifyEmailDesc": "Klicken Sie auf den Link, um Ihr Konto zu aktivieren und TimeBerlo zu nutzen.",
  "VerifyEmailSpam": "Nichts erhalten? Prüfen Sie Ihren Spam-Ordner.",
  "GoToLogin": "Zum Login",
  "EmailAlreadyRegistered": "Ein Konto mit dieser E-Mail existiert bereits",
  "PasswordRequirements": "Das Passwort muss mindestens 8 Zeichen lang sein und Groß-, Kleinbuchstaben sowie ein Sonderzeichen enthalten",
  "OrContinueWith": "oder fortfahren mit",
  "ComingSoon": "Demnächst",
  "NeedAnAccount": "Konto benötigt",
  "ForgotPassword": "Passwort vergessen",
  "AlreadyRegistered": "Bereits registriert",
  "PleasePutYourEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "Send": "Senden",
  "SendReminder": "Erinnerung senden",
  "Company": "Unternehmen",
  "січень": "Januar",
  "лютий": "Februar",
  "березень": "März",
  "квітень": "April",
  "травень": "Mai",
  "червень": "Juni",
  "липень": "Juli",
  "серпень": "August",
  "вересень": "September",
  "жовтень": "Oktober",
  "листопад": "November",
  "грудень": "Dezember",
  "Monday": "Montag",
  "Tuesday": "Dienstag",
  "Wednesday": "Mittwoch",
  "Thursday": "Donnerstag",
  "Friday": "Freitag",
  "Saturday": "Samstag",
  "Sunday": "Sonntag",
  // CRM & Community
  "CRM": "CRM",
  // Tasks
  "TasksNav": "Aufgaben",
  "Add task": "Aufgabe hinzufügen",
  "Search tasks": "Aufgaben suchen",
  "Assigned": "Zugewiesen",
  "Priority": "Priorität",
  "More options": "Weitere Optionen",
  "Add people": "Personen hinzufügen",
  "Add card": "Karte hinzufügen",
  "Drag to reorder": "Zum Neuordnen ziehen",
  "Drop tasks here": "Aufgaben hier ablegen",
  "Mark as done": "Als erledigt markieren",
  "Mark as not done": "Als nicht erledigt markieren",
  "Untitled": "Ohne Titel",
  "Task title…": "Aufgabentitel…",
  "Description…": "Beschreibung…",
  "All": "Alle",
  "None": "Keine",
  "Columns": "Spalten",
  "Created": "Erstellt",
  "Repeat": "Wiederholung",
  "Who can see it": "Wer es sehen kann",
  "Repeats on": "Wiederholt am",
  "Everyone": "Alle",
  "My team": "Mein Team",
  "Assignees only": "Nur Zugewiesene",
  "Only me": "Nur ich",
  "Daily": "Täglich",
  "Weekly": "Wöchentlich",
  "Monthly": "Monatlich",
  "On a date…": "An einem Datum…",
  "Created by me": "Von mir erstellt",
  "Assigned to me": "Mir zugewiesen",
  "Visible to all": "Für alle sichtbar",
  "Board settings": "Board-Einstellungen",
  "New column name…": "Neuer Spaltenname…",
  "DeleteColumnConfirm": "Diese Spalte löschen? Ihre Karten werden in eine benachbarte Spalte verschoben.",
  "Delete this card?": "Diese Karte löschen?",
  "Available": "Verfügbar",
  "Change color": "Farbe ändern",
  "Community": "Gemeinschaft",
  "Contacts": "Kontakte",
  "Organisations": "Organisationen",
  "Projects": "Projekte",
  "ContactType": "Kontakttyp",
  "OrganisationType": "Organisationstyp",
  "AddContact": "Kontakt hinzufügen",
  "ContactsList": "Kontaktliste",
  "AddOrganisation": "Organisation hinzufügen",
  "AddProject": "Projekt hinzufügen",
  "MiddleName": "Zweiter Vorname",
  "Gender": "Geschlecht",
  "Ethnicity": "Ethnizität",
  "Archive": "Archiv",
  "Pseudonymise": "Pseudonymisieren",
  "PseudonymisationQueue": "Pseudonymisierungswarteschlange",
  "ProjectPurpose": "Projektzweck",
  "Commercial": "Kommerziell",
  "Internal": "Intern",
  "Grant": "Förderung",
  "Programmes": "Programme",
  "Sessions": "Sitzungen",
  "Participants": "Teilnehmer",
  "Monitor": "Überwachen",
  "Surveys": "Umfragen",
  "Overview": "Übersicht",
  "FieldSettings": "Feldeinstellungen",
  "AddField": "Feld hinzufügen",
  "Required": "Erforderlich",
  "Hidden": "Versteckt",
  "FieldType": "Feldtyp",
  "Section": "Abschnitt",
  "AddressLine1": "Adresszeile 1",
  "AddressLine2": "Adresszeile 2",
  "Country": "Land",
  "FindAddress": "Adresse suchen",
  "SelectAddress": "Adresse auswählen",
  "CharityNumber": "Wohltätigkeitsnummer",
  "CompanyRegNumber": "Handelsregisternummer",
  "VatNumber": "USt-IdNr.",
  "EoriNumber": "EORI-Nummer",
  "EmployeesNumber": "Anzahl der Mitarbeiter",
  "ContractValue": "Vertragswert",
  "ContractRef": "Vertragsreferenz",
  "IsActive": "Aktiv",
  "IsPseudonymised": "Pseudonymisiert",
  "SortOrder": "Sortierreihenfolge",
  "Slug": "Slug",
  "Icon": "Symbol",
  "ColorType": "Farbe",
  "FieldConfig": "Feldkonfiguration",
  "Group": "Gruppe",
  "ProjectType": "Projekttyp",
  "Fields": "Felder",
  "ContactFields": "Kontaktfelder",
  "SystemFields": "Systemfelder",
  "CustomFields": "Felder",
  "ProfileFields": "Profilfelder",
  "ProfileWeight": "Gewichtung",
  "AdditionalFields": "Zusätzliche Felder",
  "ProfileCompletion": "Profilvollständigkeit",
  "HrUserProfile": "Benutzerprofil",
  "Field": "Feld",
  "Values": "Werte",
  "Visible": "Sichtbar",
  // Gender options
  "gender_Male": "Männlich",
  "gender_Female": "Weiblich",
  "gender_NonBinary": "Nicht-binär",
  "gender_Transgender": "Transgender",
  "gender_Other": "Sonstiges",
  "gender_PreferNotToSay": "Keine Angabe",
  // Ethnicity options
  "ethnicity_1": "Englisch, Walisisch, Schottisch, Nordirisch oder Britisch",
  "ethnicity_2": "Irisch",
  "ethnicity_3": "Sinti und Roma oder Irische Reisende",
  "ethnicity_4": "Roma",
  "ethnicity_5": "Sonstiger weißer Hintergrund",
  "ethnicity_6": "Weiß und Schwarzkaribisch",
  "ethnicity_7": "Weiß und Schwarzafrikanisch",
  "ethnicity_8": "Weiß und Asiatisch",
  "ethnicity_9": "Sonstiger gemischter oder mehrfacher ethnischer Hintergrund",
  "ethnicity_10": "Indisch",
  "ethnicity_11": "Pakistanisch",
  "ethnicity_12": "Bangladeschisch",
  "ethnicity_13": "Chinesisch",
  "ethnicity_14": "Sonstiger asiatischer Hintergrund",
  "ethnicity_15": "Afrikanisch",
  "ethnicity_16": "Karibisch",
  "ethnicity_17": "Sonstiger schwarzer, schwarzbritsicher oder karibischer Hintergrund",
  "ethnicity_18": "Arabisch",
  "ethnicity_19": "Sonstige ethnische Gruppe",
  "ethnicity_20": "Keine Angabe",
  "EditFields": "Felder bearbeiten",
  "SelectField": "Feld auswählen",
  "Apply": "Anwenden",
  "Value": "Wert",
  // Training
  "Training": "Schulung",
  "TrainingMyCourses": "Meine Schulungen",
  "TrainingAddCourse": "Kurs hinzufügen",
  "TrainingEditCourse": "Kurs bearbeiten",
  "TrainingAddPage": "Seite hinzufügen",
  "TrainingEditPage": "Seite bearbeiten",
  "TrainingAddQuestion": "Frage hinzufügen",
  "TrainingEditQuestion": "Frage bearbeiten",
  "TrainingMyLearning": "Kurse",
  "TrainingLibrary": "Bibliothek",
  "TrainingResults": "Ergebnisse",
  "TrainingManage": "Verwalten",
  "TrainingCreateCourse": "Kurs erstellen",
  "TrainingStart": "Starten",
  "TrainingRetake": "Wiederholen",
  "TrainingReview": "Überprüfen",
  "TrainingStartQuiz": "Quiz starten",
  "TrainingSubmit": "Test einreichen",
  "TrainingQuiz": "Quiz",
  "TrainingPages": "Seiten",
  "TrainingRead": "gelesen",
  "TrainingQuestions": "Fragen",
  "TrainingNotStarted": "Nicht begonnen",
  "TrainingPassed": "Bestanden",
  "TrainingFailed": "Nicht bestanden",
  "TrainingCorrect": "Richtig",
  "TrainingErrors": "Fehler",
  "TrainingPassThreshold": "Bestehensgrenze",
  "TrainingForAll": "Allen Mitarbeitern zuweisen",
  "TrainingPageImage": "Seitenbild / Anhang",
  "TrainingUploadImage": "Bild hochladen",
  "TrainingImageTooBig": "Bild muss kleiner als 5 MB sein",
  "TrainingEnterTitle": "Bitte einen Titel eingeben",
  "TrainingEnterQuestion": "Bitte den Fragetext eingeben",
  "TrainingMinAnswers": "Bitte mindestens 2 Antworten ausfüllen",
  "TrainingMarkCorrect": "Bitte mindestens eine richtige Antwort markieren",
  "TrainingMarkCorrectHint": "Aktivieren Sie das Kästchen neben der richtigen Antwort(en)",
  "TrainingRetakeMessage": "Ergebnis liegt unter {threshold}%. Wir empfehlen, den Kurs zu wiederholen.",
  "TrainingAnswers": "Antwortoptionen",
  "TrainingAnswer": "Antwort",
  "TrainingQuestionText": "Frage",
  "TrainingSaveSuccess": "Erfolgreich gespeichert",
  "TrainingErrorOccurred": "Ein Fehler ist aufgetreten",
  "TrainingQuestionType": "Fragetyp",
  "TrainingMarkAllCorrect": "Alle richtigen Antworten markieren",
  "TrainingSelectUsers": "Benutzern zuweisen",
  "TrainingRetakeInterval": "Alle N Tage wiederholen",
  "TrainingMultipleChoice": "Mehrere richtige Antworten",
  "TrainingTrueFalse": "Ja / Nein",
  "TrainingSingleChoice": "Eine richtige Antwort",
  "TrainingYesNo": "Ja / Nein",
  "TrainingSelectAll": "Alle zutreffenden auswählen",
  "TrainingAnswered": "Beantwortet",
  "TrainingPagesRead": "Gelesene Seiten",
  "TrainingQuizScore": "Quiz-Ergebnis",
  "TrainingProgress": "Fortschritt",
  "TrainingContent": "Inhalt",
  "TrainingKnowledgeCheck": "Wissensüberprüfung",
  "TrainingModule": "Modul",
  "TrainingInProgress": "In Bearbeitung",
  "TrainingCompleted": "Abgeschlossen",
  "TrainingCoursesCount": "Kurse",
  "TrainingTeamProgress": "Teamfortschritt",
  "TrainingCourseSettings": "Kurseinstellungen",
  "TrainingAssignedTo": "Zugewiesen an",
  "TrainingUsersNotStarted": "Nicht begonnen",
  "TrainingRemindAll": "Unvollständige erinnern",
  "TrainingRemindSent": "Erinnerung gesendet",
  "TrainingResetResults": "Abschlüsse zurücksetzen",
  "TrainingResetConfirm": "Alle Ergebnisse für diesen Kurs zurücksetzen? Benutzer müssen ihn erneut absolvieren.",
  "TrainingDeleteCourse": "Kurs löschen",
  "TrainingDeleteConfirm": "Diesen Kurs löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "TrainingNotCompleted": "Nicht abgeschlossen",
  "TrainingAllUsers": "Alle",
  "TrainingReports": "Berichte",
  "TrainingCongrats": "Herzlichen Glückwunsch!",
  "TrainingRemaining": "Verbleibend",
  "TrainingHtmlView": "HTML",
  "TrainingVisualView": "Visuell",
  "TrainingInsertVideoUrl": "Video-URL einfügen (YouTube, Vimeo…)",
  "TrainingPublishDate": "Veröffentlichungsdatum",
  "TrainingScheduled": "Geplant",
  "TrainingByDepartment": "Nach Abteilung",
  "TrainingNotifyUsers": "Benachrichtigen",
  "TrainingNotifySent": "Benachrichtigungen gesendet",
  "TrainingRemindUsers": "Erinnerung senden",
  "TrainingReminderSent": "Erinnerungen gesendet",
  "HidePanel": "Bereich ausblenden",
  "Disk": "Ablage",
  "DiskUpload": "Hochladen",
  "DiskAllFiles": "Alle Dateien",
  "DiskImages": "Bilder",
  "DiskDocuments": "Dokumente",
  "DiskVideos": "Videos",
  "DiskDeleteFile": "Datei löschen",
  "DiskPickFile": "Datei wählen",
  "DiskFiles": "Dateien",
  "DiskStorage": "Speicher",
  "DiskTotalUsed": "Belegt",
  "DiskFolders": "Ordner",
  "DiskFree": "frei",
  "Content": "Inhalt",
  "Save": "Speichern",
  "Payroll": "Gehaltsabrechnung",
  "Income": "Einkommen",
  "Balance": "Guthaben",
  "Incoming": "Eingehend",
  "Outgoing": "Ausgehend",
  "Transactions": "Transaktionen",
  "AddIncome": "Einkommen hinzufügen",
  "FillRequired": "Bitte Pflichtfelder ausfüllen",
  "InviteUser": "Benutzer einladen",
  "InviteSent": "Einladung gesendet",
  "InviteCreatedNoMail": "Benutzer erstellt, aber die Einladungs-E-Mail wurde nicht gesendet — SMTP-Einstellungen des Unternehmens prüfen.",
  "InviteHint": "Es wird eine Einladungs-E-Mail mit einem Portal-Link gesendet. Die Person legt ihr Passwort fest und vervollständigt beim ersten Login ihr Profil.",
  "SendInvite": "Einladung senden",
  "InvalidEmail": "Ungültige E-Mail",
  "DefaultRoleForNew": "Standardrolle für neue Mitarbeiter",
  "MakeDefaultForNew": "Als Standard für neue Benutzer festlegen",
  "SystemRole": "System",
  "SystemRoleHint": "Systemrolle — kann nicht gelöscht werden",
  "HrRoundingDay": "Rundung (Tage)",
  "HrRoundingHour": "Rundung (Stunden)",
  "HrRule_up_day": "Auf ganzen Tag aufrunden",
  "HrRule_up_half_day": "Auf halben Tag aufrunden",
  "HrRule_nearest_half_day": "Auf nächsten halben Tag",
  "HrRule_up_hour": "Auf ganze Stunde aufrunden",
  "HrRule_up_half_hour": "Auf halbe Stunde aufrunden",
  "HrRule_nearest_half_hour": "Auf nächste halbe Stunde",
  "HrRule_none": "Keine Rundung",
  "HrUseRounding": "Urlaubsanspruch runden",
  "HrUnitDay": "Tag",
  "HrUnitHour": "Stunde",
  "HrRuleWordUp": "auf",
  "HrRuleWordNearest": "auf nächste",
  "HrRuleWordDown": "ab auf",
  "HrRuleWordUpFrom": "aufrunden ab",
  "HrStepWholeWord": "ganzen",
  "HrRoundingDescPrefix": "Anspruch wird gerundet",
  "HrFromSettings": "Regel aus HR-Einstellungen",
  "HrRoundingNoneCfg": "Keine Rundungsregel in den HR-Einstellungen — Wert bleibt exakt.",
  "HrRoundingOffDesc": "Anspruch wird exakt angezeigt, ohne Rundung.",
  "HrRoundedLabel": "Gerundet",
  "HrNoRounding": "Keine Rundung",
  "HrRoundingIntro": "Wie der Jahresanspruch gerundet wird. Schwelle = Bruchteil eines Schritts, ab dem aufgerundet wird (0 = immer auf, 0.5 = standard, 1 = immer ab).",
  "HrStepWhole": "Ganz",
  "HrStepHalf": "0.5",
  "HrStepQuarter": "0.25",
  "HrStepTenth": "0.1",
  "HrRuleAlwaysUp": "Immer auf (≥0)",
  "HrRuleUp25": "Auf ab 0.25",
  "HrRuleUp30": "Auf ab 0.3",
  "HrRuleStandard": "Standard (≥0.5)",
  "HrRuleAlwaysDown": "Immer ab (≥1)",
  "HrRuleCustom": "Eigen…",
  "HrRoundUpFrom": "Aufrunden ab",
  "HrErrAfterNext": "Das Datum muss vor der nächsten Musteränderung liegen.",
  "HrContractAfterSegment": "Vertragsbeginn muss vor der nächsten Musteränderung liegen ({date}). Diese Änderung zuerst verschieben oder entfernen.",
  "HrAutoCorr": "auto",
  "HrErrBeforePrev": "Das Datum muss nach der vorherigen Musteränderung liegen.",
  "HrRoundingOff": "keine Rundung",
  "FillProfileTitle": "Profil vervollständigen",
  "FillProfileHint": "Willkommen! Nehmen Sie sich eine Minute Zeit, um Ihre Daten zu vervollständigen.",
  "RemindNextLogin": "Beim nächsten Login erinnern",
  "SaveAndClose": "Speichern",
  "EmergencyContact": "Notfallkontakt",
  "SetPassword": "Passwort festlegen",
  "OrgTree": "Organigramm",
  "OrgChart": "Organigramm",
  "OrgChartEmployees": "Mitarbeiter",
  "OrgChartDepartments": "Abteilungen",
  "OrgChartManagers": "Manager",
  "OrgChartLevels": "Ebenen",
  "ExpandAll": "Erweitern",
  "CollapseAll": "Einklappen",
  "AllDepartments": "Alle Abteilungen",
  "NoDepartment": "Keine Abteilung",
  "EditMode": "Bearbeitungsmodus",
  "AddUserToDept": "Hinzufügen",
  "AddNewUser": "Neu",
  "AddExistingUser": "Bestehend",
  "AddSubDept": "Unterabt.",
  "MoveHere": "Hierher verschieben",
  "AddHere": "Hinzufügen (Duplikat)",
  "OrgManagers": "Vorgesetzte",
  "OrgEmployees": "Mitarbeiter",
  "DeptHasUsers": "Löschen nicht möglich: Abteilung hat Mitarbeiter",
  "OrgSearch": "Nach Name oder Titel suchen...",
  "OrgAllDepts": "Alle Abteilungen",
  "OrgSortAZ": "Name A → Z",
  "OrgSortZA": "Name Z → A",
  "OrgStatusActive": "Aktiv",
  "OrgStatusInactive": "Inaktiv",
  "Deactivate": "Deaktivieren",
  "Reactivate": "Reaktivieren",
  "ActiveUsers": "Aktive Benutzer",
  "InactiveUsers": "Inaktive Benutzer",
  "OrgStatusAll": "Alle",
  "OrgTreeView": "Baum",
  "OrgCardsView": "Karten",
  "OrgListView": "Liste",
  "Inactive": "Inaktiv",
  "OrgTabCalendar": "Kalender",
  // History / Logs
  "Logs": "Protokolle",
  "LogService": "Dienst",
  "LogSuccess": "Erfolg",
  "LogError": "Fehler",
  "AddTemplate": "Vorlage hinzufügen",
  "maximum20characters": "Maximal 20 Zeichen",
  "HoursPerWeek": "Stunden pro Woche",
  // Role permissions — module hints
  "RoleHint_finance": "Zugriff auf Finanzen: Ausgaben, Einnahmen, Gehaltsabrechnung, Kfz-Kosten.",
  "RoleHint_timesheets": "Stundenzettel — Erfassung der täglich geleisteten Arbeitsstunden.",
  "RoleHint_toil": "Freizeitausgleich (TOIL) — Mehrarbeitsstunden gegenüber dem Vertrag.",
  "RoleHint_equipment": "Geräteregister — Geräte, Werkzeuge, Unternehmensressourcen.",
  "RoleHint_hr": "HR-Bereich: Mitarbeiterverzeichnis, Organigramm, Abteilungen.",
  "RoleHint_booking": "Raum- und Ressourcenbuchung für Besprechungsräume.",
  "RoleHint_docs": "Dokumentenspeicher: Richtlinien, Verträge, Vorlagen.",
  "RoleHint_crm": "CRM — Kontakte, Organisationen und Projekte.",
  "RoleHint_community": "Community: Programme, Sitzungen, Teilnehmer.",
  "RoleHint_training": "E-Learning: Kurse, Tests, Schulungsaufzeichnungen.",
  "RoleHint_disk": "Dateispeicher — Hochladen, Organisieren, Teilen von Dateien.",
  "RoleHint_reports": "Berichte: Stundenzettel, Abwesenheiten, Gehaltsabrechnung, Analytik.",
  "RoleHint_orders": "Kundenaufträge, Serviceanfragen, Projektverfolgung.",
  "RoleHint_settings": "Unternehmenseinstellungen: Zeitzone, Währung, E-Mail, Arbeitszeiten.",
  // Role permissions — tab hints
  "RoleHint_finance_expenses": "Eigene — eigene Ausgaben. Abt. — Abteilung. Alle — alle Unternehmensausgaben.",
  "RoleHint_finance_income": "Eigene — eigene Einnahmen. Abt. — Abteilung. Alle — alle Einnahmen.",
  "RoleHint_finance_payroll": "Eigene — eigene Gehaltszettel. Alle — alle Gehaltsabrechnungen verwalten.",
  "RoleHint_finance_car_expenses": "Eigene — eigene Kfz-Kosten. Abt. — Abteilung. Alle — alle Fahrtenkosten.",
  "RoleHint_timesheets_access": "Eigene — eigener Stundenzettel. Abt. — Abteilung. Alle — alle Stundenzettel.",
  "RoleHint_toil_access": "Eigene — eigenes Guthaben. Abt. — Team. Alle — alle Mitarbeiter.",
  "RoleHint_equipment_access": "Eigene — dem Nutzer zugewiesene Geräte. Abt. — Abteilung. Alle — alles.",
  "RoleHint_hr_access": "Eigene — eigenes Profil. Abt. — Abteilungsmitglieder. Alle — alle Mitarbeiter.",
  "RoleHint_booking_access": "Eigene — eigene Buchungen. Abt. — Abteilung. Alle — alle Buchungen.",
  "RoleHint_docs_access": "Eigene — eigene Dokumente. Abt. — Abteilungsordner. Alle — alle Dokumente.",
  "RoleHint_community_access": "Eigene — eigene Sitzungen. Abt. — Abteilungsprogramme. Alle — alle Daten.",
  "RoleHint_disk_access": "Eigene — eigene Dateien. Abt. — geteilte Abteilungsdateien. Alle — alles.",
  "RoleHint_reports_access": "Eigene — eigene Daten. Abt. — Abteilungsberichte. Alle — unternehmensweite Berichte.",
  "RoleHint_orders_access": "Eigene — zugewiesene Aufträge. Abt. — Abteilung. Alle — alle Aufträge.",
  // Role permissions — bool hints
  "RoleHint_finance_approve": "Kann Ausgabenanträge anderer Mitarbeiter genehmigen oder ablehnen.",
  "RoleHint_finance_admin": "Vollzugriff: Einstellungen, Kategorien und alle Finanzeinträge.",
  "RoleHint_timesheets_approve": "Kann wöchentliche Stundenzetteleinreichungen genehmigen oder ablehnen.",
  "RoleHint_timesheets_admin": "Einstellungen, Kategorien, Vorlagen. Kann jeden Eintrag bearbeiten.",
  "RoleHint_toil_manage": "Kann den TOIL-Saldo eines Benutzers manuell anpassen.",
  "RoleHint_hr_manage": "Kann neue Mitarbeiterkonten erstellen und Daten bearbeiten.",
  "RoleHint_hr_admin": "Vollzugriff: Löschen, Rollen zuweisen, Abteilungen verwalten.",
  "RoleHint_booking_admin": "Kann Räume und Ressourcen erstellen, bearbeiten und löschen.",
  "RoleHint_docs_admin": "Kann Dokumente hochladen, Ordner erstellen, Lesebestätigungen verwalten.",
  "RoleHint_training_view": "Kann zugewiesene Schulungskurse ansehen und abschließen.",
  "RoleHint_training_admin": "Kann Kurse und Fragen erstellen, bearbeiten und löschen.",
  "RoleHint_disk_admin": "Kann beliebige Dateien löschen, auch Dateien anderer Nutzer.",
  "RoleHint_reports_export": "Kann Berichte als CSV/Excel herunterladen.",
  "RoleHint_orders_manage": "Kann Aufträge erstellen, Status aktualisieren und zuweisen.",
  "RoleHint_settings_admin": "Kann unternehmensweite Einstellungen, E-Mail und Portal-Setup ändern.",
  "WorkingStatus": "Arbeitsstatus",
  "WorkingStatuses": "Arbeitsstatuse",
  "AddWorkingStatus": "Status hinzufügen",
  "WorkingStatusName": "Statusname",
  "WorkingStatusColor": "Farbe",
  "WorkingStatusEmoji": "Symbol",
  "WorkingStatusSaved": "Status aktualisiert",
  "WorkingStatusClearLabel": "Status löschen",
  "WorkingStatusSetup": "Richten Sie die Arbeitsstatuse Ihres Teams ein. Systemstatuse können nicht gelöscht werden.",
  "SelectExisting": "Vorhandenen auswählen",
  "HrLeave": "Urlaub",
  "HrSickness": "Krankheit",
  "HrLateness": "Verspätung",
  "HrSettings": "HR Einstellungen",
  "HrScheduleTemplates": "Arbeitszeitvorlagen",
  "HrLeaveTypes": "Urlaubstypen",
  "HrPublicHolidays": "Feiertage",
  "HrHolidays": "Feiertage",
  "HrStatuses": "Status",
  "AbsenceLeave": "Urlaub & Feiertage",
  "Localization": "Lokalisierung",
  "Billing": "Abrechnung",
  "Tools": "Werkzeuge",
  "CompanyVehicles": "Firmenfahrzeuge",
  "ExpenseFields": "Ausgabenfelder",
  "HrAllowance": "Kontingent",
  "HrAllowanceUnit": "Einheit",
  "HrPartialDay": "Halber Tag",
  "HrRequiresApproval": "Genehmigung",
  "HrTemplateName": "Vorlagenname",
  "HrSetAsDefault": "Als Standard festlegen",
  "HrScheduleTemplatesHint": "Vorlagen definieren Arbeitszeiten. Einzeln Mitarbeitern zuweisen.",
  "HrAbsences": "Abwesenheiten",
  "HrAbsenceAll": "Alle",
  "HrAbsenceType": "Abwesenheitstyp",
  "HrAddAbsence": "Abwesenheit hinzufügen",
  "HrEditAbsence": "Abwesenheit bearbeiten",
  "HrChangeSupervisor": "Vorgesetzten überschreiben",
  "HrResetSupervisor": "Auf Standard-Vorgesetzten zurücksetzen",
  "HrEmployee": "Mitarbeiter",
  "HrAddLeave": "Urlaub hinzufügen",
  "HrAddSickness": "Krankheit hinzufügen",
  "HrAddLateness": "Verspätung hinzufügen",
  "HrReason": "Grund",
  "HrCertified": "Zertifiziert",
  "HrMinutesLate": "Minuten zu spät",
  "From": "Von",
  "Today": "Heute",
  "Error": "Fehler",
  "Min": "Min",
  "HShort": "Std",
  "DShort": "T",
  "HrOverview": "Übersicht",
  "HrCalendar": "Kalender",
  "HrThisMonth": "Dieser Monat",
  "HrOut": "abwesend",
  "HrViewMonth": "Monatsansicht",
  "HrViewTimeline": "Timeline-Ansicht",
  "HrToApprove": "Zu genehmigen",
  "HrMyAbsences": "Meine Abwesenheiten",
  "HrOutToday": "Heute abwesend",
  "HrPendingApproval": "Ausstehende Genehmigung",
  "HrUpcomingBirthdays": "Geburtstage (2 Wo)",
  "HrExpiringDocs": "Ablaufende Dokumente",
  "HrUpcomingEvents": "Bevorstehende Ereignisse",
  "HrBirthday": "Geburtstag",
  "HrLicenseExpiry": "Lizenzablauf",
  "HrProbationEnd": "Probezeitende",
  "HrUsed": "Verbraucht",
  "HrRemaining": "Verbleibend",
  "HrApprove": "Genehmigen",
  "HrReject": "Ablehnen",
  "HrSubmit": "Einreichen",
  "HrCancel": "Zurückziehen",
  "HrApproved": "Genehmigt",
  "HrRejected": "Abgelehnt",
  "HrSubmitted": "Antrag eingereicht",
  "HrCancelled": "Zurückgezogen",
  "HrRejectReason": "Ablehnungsgrund",
  "HrDuration": "Dauer",
  "HrDurFull": "Ganzer Tag",
  "HrDurHalfAm": "Halbtags (vormittags)",
  "HrDurHalfPm": "Halbtags (nachmittags)",
  "HrDurCustom": "Stunden angeben",
  "HrDurFullOnly": "Ganzer Tag (Dauerauswahl in Einstellungen deaktiviert)",
  "HrSickNote": "Krankmeldung / Dokument",
  "HrRequests": "Abwesenheit",
  "Male": "Männlich",
  "Female": "Weiblich",
  "Others": "Andere",
  "HrTabPersonal": "Persönlich",
  "HrTabEmployment": "Beschäftigung",
  "HrTabOvertime": "Überstunden",
  "HrTabEmergencies": "Notfallkontakte",
  "HrTabSensitive": "Sensibel",
  "HrTabCustom": "Benutzerdefiniert",
  "HrProbationStart": "Probezeitbeginn",
  "HrNoticePeriod": "Kündigungsfrist",
  "HrDayOff": "Frei",
  "HrBreak": "Pause",
  "HrSource": "Quelle",
  "HrEcName": "Kontaktname",
  "HrEcRelationship": "Beziehung",
  "HrEcPhone": "Telefon",
  "HrEcEmail": "E-Mail",
  "HrSensitiveStub": "Platzhalter — Felder deaktiviert. Speichern, Verschlüsselung und Zugriff folgen später.",
  "HrSensNINO": "Sozialversicherungsnr.",
  "HrSensTaxCode": "Steuernummer",
  "HrSensPassport": "Passnummer",
  "HrSensBankName": "Bank",
  "HrSensAccountHolder": "Kontoinhaber",
  "HrSensAccountNumber": "Kontonummer",
  "HrSensSortCode": "Bankleitzahl",
  "HrSensIBAN": "IBAN",
  "Rel_spouse": "Ehepartner",
  "Rel_partner": "Partner",
  "Rel_relative": "Verwandter",
  "Rel_parent": "Elternteil",
  "Rel_child": "Kind",
  "Rel_sibling": "Geschwister",
  "Rel_friend": "Freund",
  "Rel_other": "Andere",
  "HrDelete": "Löschen",
  "HrConfirmDelete": "Dieses Muster löschen?",
  "HrDuplicate": "Duplizieren",
  "HrWorking": "Arbeitstag",
  "HrUsersUsing": "nutzen dieses Muster",
  "HrUseToil": "Überstunden zählen (TOIL)",
  "HrUseToilDesc": "Wenn aus, wird TOIL beim Absenden des Stundenzettels auf null ausgeglichen (keine Überstunden-Ansammlung).",
  "HrLeaveUnit": "Urlaub gezählt in",
  "HrUnitDays": "Tagen",
  "HrUnitHours": "Stunden",
  "HrPhIntro": "Legen Sie fest, ob Mitarbeiter dieses Musters an Feiertagen arbeiten und ob diese zum Jahresurlaub zählen.",
  "HrPhDeducted": "Abgezogen",
  "HrPhDeductedDesc": "Sie haben an Feiertagen frei, die sie normalerweise arbeiten — abgezogen vom Jahresurlaub.",
  "HrPhNotDeducted": "Nicht abgezogen",
  "HrPhNotDeductedDesc": "Sie haben an Feiertagen frei, die sie normalerweise arbeiten — zusätzlich zum Jahresurlaub.",
  "HrPhWorks": "Arbeitet an Feiertagen",
  "HrPhWorksDesc": "Feiertage gelten als normaler Tag — kein freier Tag.",
  "HrContractTypes": "Vertragsarten",
  "PatternHistory": "Musterverlauf",
  "ChangePattern": "Muster ändern",
  "HrSegmentFrom": "Gültig ab",
  "HrNoContractDate": "Eintrittsdatum ist nicht gesetzt — das erste Segment nutzt das Erstellungsdatum des Kontos. Bitte ausfüllen.",
  "HrAddSegment": "Musterwechsel hinzufügen",
  "HrOngoing": "laufend",
  "HrRecalculate": "Neu berechnen",
  "HrCurrentPattern": "Aktuelles Muster",
  "HrBaseByPatterns": "Basis nach Mustern",
  "HrPatternsWord": "Muster",
  "HrWeightedPerWeek": "Gewichtete Std/Woche",
  "HrWeeksWord": "Wochen",
  "HrPatternFromContract": "Gilt ab Vertragsbeginn · Muster unten bearbeiten",
  "HrPatternSaved": "Muster hinzugefügt",
  "HrScheduledChange": "Geplant",
  "HrDateFromContract": "Datum wird vom Vertragsbeginn übernommen (nicht bearbeitbar)",
  "HrAutoApplyHint": "Wird automatisch am {date} um 00:00 angewendet ({tz})",
  "HrAddHint": "Beim Speichern läuft eine Prüfung. Falls TOIL/Urlaub betroffen sind, wirst du um Bestätigung gebeten.",
  "LocalTime": "Ortszeit",
  "HrRecalcNeeded": "Neuberechnung nach Musterwechsel erforderlich",
  "HrRecalcWarnBody": "Muster gespeichert. Die Prüfung fand Abweichungen bei TOIL und Urlaub. Prüfen und Übernehmen, oder Überspringen, um aktuelle Werte zu behalten.",
  "HrRecalcLogged": "Beim Übernehmen wird ein Audit-Log-Eintrag geschrieben",
  "Skip": "Überspringen",
  "AllLogs": "Alle Logs",
  "RecalcLogTab": "TOIL- & Urlaubsneuberechnung",
  "LogTrigger": "Auslöser",
  "ChangedBy": "Geändert von",
  "HrRecalcPreview": "Vorschau der Neuberechnung",
  "HrRecalcNoChanges": "Keine Änderungen — alles ist aktuell.",
  "HrApplyChanges": "Änderungen übernehmen",
  "Was": "War",
  "Now": "Jetzt",
  "NetToilFiltered": "Netto-TOIL (gefiltert)",
  "Entries": "Einträge",
  "DateOrSource": "Datum oder Quelle...",
  "Clear": "Zurücksetzen",
  "Week": "Woche",
  "Logged": "Erfasst",
  "Report": "Bericht",
  "Manual": "Manuell",
  "Comment": "Kommentar",
  "Current": "Aktuell",
  "Initial": "Anfänglich",
  "Loading": "Wird geladen…",
  "HrResetPassword": "Passwort zurücksetzen",
  "HrDisableAccount": "Konto deaktivieren",
  "Activate": "Aktivieren",
  "HrActiveOnly": "Nur aktive",
  "HrNewPassword": "Neues Passwort",
  "HrSchedule": "Arbeitsplan",
  "Start": "Beginn",
  "End": "Ende",
  "EffectiveFrom": "Gültig ab",
  "PreviousPattern": "Vorheriges Muster",
  "ReasonForUpdate": "Grund der Änderung",
  "ActionedDate": "Aktionsdatum",
  "NoPatternHistory": "Noch keine Musteränderungen aufgezeichnet.",
  "HrWorkingPattern": "Arbeitsmuster",
  "HrWorkingPatterns": "Arbeitsmuster",
  "HrAddPattern": "Muster hinzufügen",
  "HrPatternName": "Mustername",
  "HrWorksHolidays": "Arbeitet an Feiertagen",
  "HrPerWeek": "pro Woche",
  "HrExclBreaks": "ohne Pausen",
  "Default": "Standard",
  "Saved": "Gespeichert",
  "HrGeneral": "Allgemein",
  "HrAbsenceSettings": "Abwesenheitseinstellungen",
  "HrAllowPartialDay": "Dauerauswahl erlauben (halber Tag, Stunden)",
  "HrAllowPartialDayHint": "Wenn aus, werden alle Abwesenheiten als ganzer Tag ohne Auswahl eingereicht (Standard).",
  "HrStatus_draft": "Entwurf",
  "HrStatus_pending": "Ausstehend",
  "HrStatus_approved": "Genehmigt",
  "HrStatus_rejected": "Abgelehnt",
  "HrStatus_cancelled": "Storniert",
  "HrStatus_recorded": "Erfasst",
  "HrStatusApproved": "Genehmigt",
  "HrStatusPending": "Ausstehend",
  "HrStatusRecorded": "Erfasst",
  "WD_Mon": "Mo",
  "WD_Tue": "Di",
  "WD_Wed": "Mi",
  "WD_Thu": "Do",
  "WD_Fri": "Fr",
  "WD_Sat": "Sa",
  "WD_Sun": "So",
  "ReturnDate": "Rückkehrdatum",
  "ContractTypeUseTOIL": "TOIL verwenden",
  "ToilAutoCorrection": "Autokorrektur",
  "err_save_generic": "Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.",
  "err_email_in_use": "Diese E-Mail-Adresse wird bereits von einem anderen Mitarbeiter verwendet.",
  "err_invalid_enum": "Ungültiger Wert in einem Feld (z. B. Geschlecht oder Status).",
  "err_invalid_date": "Ungültiges Datum in einem der Datumsfelder.",
  "err_invalid_number": "Ungültige Zahl in einem der Zahlenfelder.",
  "err_fk_not_found": "Zugehöriger Datensatz nicht gefunden (Abteilung, Vertragstyp oder Rolle wurde möglicherweise gelöscht).",
  "Dashboard": "Dashboard",
  "Finance": "Finanzen",
  "HR": "HR · Personal",
  "Docs": "Dokumente",
  "news_announcements": "Unternehmensankündigungen",
  "news_add": "Ankündigung hinzufügen",
  "news_edit": "Bearbeiten",
  "news_delete": "Löschen",
  "news_pin": "Anpinnen",
  "news_unpin": "Lospin",
  "news_pinned": "Angeheftet",
  "news_publish": "Veröffentlichen",
  "news_save": "Änderungen speichern",
  "news_all": "Alle Neuigkeiten",
  "news_title_label": "Titel",
  "news_body_label": "Nachricht",
  "news_title_placeholder": "z.B. Büroschließung — Feiertag 23. Juni",
  "news_body_placeholder": "Schreiben Sie Ihre Ankündigung hier…",
  "news_emoji_label": "Symbol (Emoji)",
  "news_color_label": "Symbol-Hintergrundfarbe",
  "news_pin_label": "Diese Ankündigung anpinnen",
  "news_pin_hint": "Angeheftete Beiträge erscheinen immer zuerst und werden mit einem Symbol hervorgehoben",
  "news_preview_label": "Vorschau",
  "RoleHint_dashboard_settings": "Zugang zu Dashboard-Einstellungen und Verwaltung aller Ankündigungen (Anheften, beliebige löschen).",
  "RoleHint_dashboard_widget_feed_enabled": "Das Newsfeed-Widget kann zum Dashboard hinzugefügt werden.",
  "RoleHint_dashboard_edit_own": "Kann Blöcke auf dem eigenen Dashboard anordnen, hinzufügen und entfernen.",

  "AddedBy": "Hinzugefügt von",
  "DirectLink": "Direktlink",

  // ImageUpload universal component
  "ImgUpTitle": "Bild einfügen",
  "ImgUpTitleSub": "Hochladen, zuschneiden und optimieren",
  "ImgUpFile": "Datei",
  "ImgUpCamera": "Kamera",
  "ImgUpDrop": "Bild hierher ziehen",
  "ImgUpDropSub": "oder klicken zum Auswählen · bis 20 MB",
  "ImgUpChooseFile": "Datei auswählen",
  "ImgUpEditorTitle": "Bildeditor",
  "ImgUpMode": "Modus",
  "ImgUpModeOptimize": "Optimieren",
  "ImgUpModeCrop": "Zuschneiden",
  "ImgUpModeOriginal": "Original",
  "ImgUpModeOptimizeHint": "Optimierungsmodus · kein Zuschnitt",
  "ImgUpModeOriginalHint": "Datei wird unverändert hochgeladen",
  "ImgUpRatio": "Seitenverhältnis",
  "ImgUpFree": "Frei",
  "ImgUpZoom": "Zoom",
  "ImgUpRotation": "Drehung",
  "ImgUpQuality": "Qualität",
  "ImgUpMaxWidth": "Max. Breite",
  "ImgUpOriginalSize": "Original",
  "ImgUpAfterSize": "Ergebnis",
  "ImgUpFilename": "Dateiname",
  "ImgUpInsert": "Einfügen ↵",
  "ImgUpBack": "← Zurück",
  "ImgUpSnap": "Foto aufnehmen",
  "ImgUpRetake": "↩ Wiederholen",
  "ImgUpCamError": "Kamera nicht verfügbar. Bitte Zugriff in den Browsereinstellungen erlauben.",
  "ImgUpOriginalWarn": "Sind Sie sicher?",
  "ImgUpOriginalWarnText": "Originaldatei ist {size}. Nach Optimierung wären es ~{opt} — {pct}% kleiner.",
  "ImgUpCompress": "Besser komprimieren",
  "ImgUpUploadOriginal": "Trotzdem Original hochladen",
  "ImgUpProcessing": "Verarbeitung…",

  // Settings — Users Management
  "SettingsUsersTitle": "Firmenmitarbeiter",
  "ResetPassword": "Passwort zurücksetzen",
  "NewPassword": "Neues Passwort",
  "PasswordMinLength": "Mindestens 6 Zeichen",
  "EditRoles": "Rollen bearbeiten",
  "RolesUpdated": "Rollen aktualisiert",
  "HrLeaveBalance": "Urlaub",
  "AnnualLeave": "Jahresurlaub",
  "HrEntitlement": "Anspruch",
  "HrEntitlementBase": "Basisanspruch",
  "HrProRata": "Teiljahr",
  "HrAdjustment": "Korrektur",
  "HrAdjustments": "Korrekturen",
  "HrPending": "Geplant",
  "HrShowApproved": "Archiv",
  "HrUsage": "Nutzung",
  "HrAmount": "Menge",
  "HrUnit": "Einheit",
  "HrLeaveYear": "Urlaubsjahr",
  "HrMainLeaveType": "Haupturlaubsart",
  "HrAdjKind": "Korrekturart",
  "HrAdjKind_carryover": "Übertrag",
  "HrAdjKind_bonus": "Bonus",
  "HrAdjKind_buy": "Kauf",
  "HrAdjKind_sell": "Verkauf",
  "HrAdjKind_manual": "Manuell",
  "Employee": "Mitarbeiter",
  "Deleted": "Gelöscht",
  "Pattern": "Muster",
  "Prev": "Zurück",
  "Next": "Weiter",
  "HrLeaveRules": "Urlaubsberechnungsregeln",
  "HrLeaveYearStart": "Beginn des Urlaubsjahres",
  "HrLeaveUnitBasis": "Zähleinheit",
  "HrUnitBasis_working_days": "Arbeitstage",
  "HrUnitBasis_calendar_days": "Kalendertage",
  "HrUnitBasis_hours": "Stunden",
  "HrEntitlementFormula": "Anspruchsformel",
  "HrFormula_weeks": "Wochen × Std/Woche",
  "HrFormula_days": "Feste Tage",
  "HrFormula_hours": "Stunden",
  "HrEntitlementWeeks": "Wochen / Basistage",
  "HrAccrualMode": "Ansammlungsmodus",
  "HrAccrual_upfront": "Sofort (anteilig)",
  "HrAccrual_monthly": "Monatlich (Ansammlung)",
  "HrAccrualRate": "Ansammlungsrate (Tage/Monat)",
  "HrRounding": "Rundung",
  "HrRound_none": "Keine",
  "HrRound_half_up": "Auf 0,5 Tag aufrunden",
  "HrRound_full_up": "Auf 1 Tag aufrunden",
  "HrRound_nearest_half": "Auf nächste 0,5",
  "HrRound_tenth": "Auf 0,1",
  "HrCarryoverMax": "Übertragslimit (Tage)",
  "HrHolidayPatternInfo": "Feiertagsbehandlung wird pro Arbeitsmuster festgelegt.",
  "Month": "Monat",
  "Day": "Tag",
  "HrSelectEmployee": "Mitarbeiter auswählen, um den Urlaubssaldo zu sehen",
  "HrAbsenceHistory": "Abwesenheitsverlauf",
  "Auto": "Auto",
  "HrUnitModeHint": "Auto verwendet die Einheit aus dem Arbeitsmuster",
  "HrServiceLength": "Dienstalter",
  "HrHiredSince": "seit",
  "HrNonWorkingDay": "Dies ist ein arbeitsfreier Tag und kann nicht gebucht werden",
  "HrTimeStep": "Zeitschritt",
  "HrTimeStepHint": "Gilt für Urlaubsstunden und Zeiterfassung",
  "HrYearBasis": "Grundlage für anteilige Berechnung",
  "HrYearBasis_calendar": "Kalendertage (365 / 366 im Schaltjahr)",
  "HrYearBasis_working": "Arbeitstage (Mo–Fr, ~261 pro Jahr)",
  "HrYearBasisHint": "Nenner für die anteilige Berechnung bei Eintritt während des Jahres. 'Arbeitstage' entspricht Lohnsystemen, die 261 als Jahresbasis verwenden.",
  "HrLeaveCalc": "Urlaubsberechnung",
  "HrServiceBands": "Zusätzliche Tage nach Betriebszugehörigkeit",
  "HrServiceBandsHint": "Wird dem Haupturlaubstyp automatisch nach Einstellungsdatum hinzugefügt",
  "HrServiceYears": "Dienstjahre ≥",
  "HrExtraDays": "Zusätzliche Tage",
  "HrAddBand": "Stufe hinzufügen",
  "HrDirection": "Richtung",
  "HrAdd": "Hinzufügen",
  "HrDeduct": "Abziehen",
  "HrHours": "Stunden",
  "HrMinutes": "Minuten",
  "HrHowCalculated": "Wie berechnet",
  "HrCalcBase": "Basis (pro Jahr)",
  "HrCalcService": "Bonus für Betriebszugehörigkeit",
  "HrYearsShort": "J",
  "HrMonthsShort": "M",
  "HrEvent": "Ereignis",
  "HrCarryover": "Übertrag",
  "HrCarryoverAll": "Alle übertragen",
  "HrCarryoverRemainder": "Übertragen auf",
  "HrHoursToCarry": "Zu übertragende Stunden",
  "HrToCarry": "Zu übertragen",
  "HrCarriedOver": "Übertragen",
  "HrSkipped": "übersprungen",
  "HrNothingToCarry": "Nichts zu übertragen",
  "HrAlreadyCarried": "bereits übertragen",
  "HrDeleted": "Gelöscht",
  "Ready": "Bereit",
  "Driver": "Fahrer",
  "Drivers": "Fahrer",
  "Insurance": "Versicherung",
  "Provider": "Anbieter",
  "PolicyNumber": "Policennummer",
  "ExpiryDate": "Ablaufdatum",
  "CarExpenses": "Fahrzeugkosten",
  "AddVehicle": "Fahrzeug hinzufügen",
  "EditVehicle": "Fahrzeug bearbeiten",
  "Expired": "Abgelaufen",
  "NotSet": "Nicht gesetzt",
  "AnyDriver": "Beliebiger Fahrer",
  "AnyEmployee": "Jeder Mitarbeiter darf fahren",
  "DefaultCar": "Standardfahrzeug",
  "Petrol": "Benzin",
  "Diesel": "Diesel",
  "Electric": "Elektro",
  "Hybrid": "Hybrid",
  "Personal": "Privat",
  "Business": "Geschäftlich",
  "Mixed": "Gemischt",
  "You": "Sie",
  "SelectCars": "Fahrzeug wählen",
  "Document": "Dokument",
  "AddPolicy": "Police hinzufügen",
  "EditPolicy": "Police bearbeiten",
  "CoveredVehicles": "Abgedeckte Fahrzeuge",
  "SelectVehicles": "Fahrzeuge wählen",
  "NoVehicles": "Keine Fahrzeuge",
  "NoPolicies": "Keine Policen",
  "Contracts": "Verträge",
  "NewContract": "Neuer Vertrag",
  "UploadContract": "Hochladen",
  "ContractTitle": "Vertragstitel",
  "ContractTitlePlaceholder": "z.B. Arbeitsvertrag",
  "ContractFile": "Datei (PDF, DOCX)",
  "ContractSigned": "Unterzeichnet",
  "ContractPending": "Ausstehende Unterschrift",
  "ContractDraft": "Entwurf",
  "NoContracts": "Keine Verträge vorhanden",
  "SearchContracts": "Verträge suchen…",
  "DropContractHere": "PDF oder DOCX hier ablegen oder klicken zum Auswählen",
  "DropContractSub": "Max. 20 MB · PDF, DOCX unterstützt",
  "ElectronicSignature": "Elektronische Unterschrift",
  "DrawSignatureHint": "Zeichnen Sie Ihre Unterschrift zur Bestätigung des Dokuments",
  "SignHere": "Unterschrift hier zeichnen",
  "SignHereSub": "Maus oder Touchscreen verwenden",
  "SignatureCaptured": "Unterschrift erfasst",
  "SignAndSubmit": "Unterschreiben und absenden",
  "SignAs": "Unterschreibt als",
  "SignLegalNotice": "Mit Klick auf \"Unterschreiben und absenden\" bestätigen Sie, dass Sie dieses Dokument gelesen haben und es elektronisch unterzeichnen. Diese Unterschrift ist rechtlich bindend.",
  "BackToContracts": "Zurück zu Verträgen",
  "ContractDraftNotice": "Dieser Vertrag ist ein Entwurf. Laden Sie eine Datei hoch und senden Sie ihn zur Unterschrift.",
  "NoFileAttached": "Keine Datei angehängt",
  "DeleteContractConfirm": "Diesen Vertrag löschen?",
  "StepReview": "Prüfen",
  "StepSign": "Unterschreiben",
  "StepSubmit": "Absenden",
  "NoDrivers": "Keine Fahrer",
  "Idle": "Inaktiv",
  "DaysShort": "T",
  "CurrentDocument": "Aktuelles Dokument",
  "BrowseDocument": "Dokument hochladen",
  "TrainingPublished": "Veröffentlicht",
  "TrainingUnpublished": "Zurückgezogen",
  "TrainingDraft": "Entwurf",
  "TrainingPublishToggleHint": "Veröffentlicht / Entwurf umschalten",
  "HrRebalanceTitle": "TOIL wochenweise neu ausgleichen",
  "HrWeeksToFix": "Zu korrigierende Wochen",
  "HrDeleteManual": "Manuelle löschen",
  "HrRebalanceAll": "Alles neu ausgleichen",
  "HrToilByWeek": "TOIL nach Woche",
  "HrPatternOfWeek": "Muster der Woche",
  "HrWeekBalance": "Wochensaldo",
  "HrChanges": "Änderungen",
  "HrUsesToil": "Mit TOIL",
  "HrNoToil": "Ohne TOIL",
  "HrWeekPatternIs": "In dieser Woche gültiges Muster",
  "HrWeekUsesToil": "Muster nutzt TOIL → Überstunden fließen in den TOIL-Saldo. Report wird neu berechnet, eine überflüssige Auto-Korrektur wird entfernt, manuelle Korrekturen bleiben erhalten.",
  "HrWeekNoToil": "Muster nutzt KEIN TOIL → Überstunden werden per Auto-Korrektur auf null gesetzt, und alle manuellen Korrekturen dieser Woche werden entfernt (sie duplizieren den Ausgleich).",
  "HrReportRecalc": "Report — nach Muster neu berechnet",
  "HrToilWasNow": "TOIL war → jetzt",
  "HrAutoCorrection": "Auto-Korrektur (Überstunden auf null)",
  "HrAction": "Aktion",
  "HrManualOfWeek": "Manuelle Korrekturen der Woche",
  "HrSum": "Summe",
  "HrWhatHappens": "Ergebnis",
  "HrKeep": "behalten",
  "HrRebalanceWeek": "Woche neu ausgleichen",
  "HrCreate": "erstellen",
  "HrUpdate": "aktualisieren",
  "HrRebalanceNote": "Jede Anwendung schreibt einen Audit-Log-Eintrag. Ohne Bestätigung wird nichts geändert.",
  "HrRecalcReportLine": "Report nach Muster neu berechnen",
  "HrManualCorr": "Manuelle Korrektur",
  "HrWeekResult": "Wochenergebnis",
  "HrRebalanceAllBody": "Alle Wochen unten werden auf einmal neu ausgeglichen und der Jahresurlaub neu berechnet.",
  "HrWeeksToRebalance": "Wochen zum Neuausgleich",
  "HrManualToDelete": "manuelle Korrekturen zum Löschen",
  "HrLeaveToRecalc": "Urlaubszeiträume zur Neuberechnung",
  "HrRebalance": "Neu ausgleichen",
  "DriverLicence": "Führerschein",
  "LicenceNotAdded": "Nicht hinzugefügt",
  "Until": "bis",
  "LicenceNumber": "Führerscheinnummer",
  "LicenceCategories": "Kategorien (Fahrzeugtypen)",
  "SelectCategories": "Kategorien wählen",
  "LicencePhotos": "Führerschein-Fotos",
  "TwoSides": "Vorder- & Rückseite",
  "FrontSide": "Vorderseite",
  "BackSide": "Rückseite",
  "UploadPhoto": "Foto hochladen",
  "LicenceHint": "Alle Felder und beide Fotos sind erforderlich. Beim Erstellen einer Fahrzeugkostenabrechnung prüft das System, dass der Führerschein hinzugefügt und gültig ist.",
  "LicencePhotosRequired": "Beide Führerschein-Fotos sind erforderlich",
  "NoLicence": "Kein Führerschein",
  "LicenceOk": "Führerschein",
  "LicenceExpiredShort": "Führerschein abgelaufen",
  "MyLicence": "Mein Führerschein",
  "FromWhom": "Von wem",
  "ClaimDateLimits": "Antragsdatum-Limits",
  "ClaimDaysHint": "Legen Sie die maximale Anzahl von Tagen in der Vergangenheit fest, die ein Mitarbeiter bei der Einreichung eines Antrags auswählen kann. Leer lassen für beliebiges Datum.",
  "ExpensesClaimDays": "Ausgaben — max. Tage zurück",
  "ExpensesClaimDaysHint": "z.B. 30 — Belege müssen innerhalb von 30 Tagen nach dem Kauf eingereicht werden",
  "CarExpensesClaimDays": "Fahrzeugkosten — max. Tage zurück",
  "CarExpensesClaimDaysHint": "z.B. 30 — Kilometeranträge müssen innerhalb von 30 Tagen eingereicht werden",
  "SelectEmployee": "Mitarbeiter auswählen",
  "NoEmployeesWithoutLicense": "Alle Mitarbeiter haben bereits einen Führerschein",
  "HrMyRequest": "Mein Antrag",
  "HrForEmployee": "Für {{name}} · von HR erfasst",
  "Optional": "optional",
  "HrNotePlaceholder": "Notiz für Ihre Führungskraft",
  "HrResetFullDay": "Ganzer Tag",
  "HrFitNote": "Krankmeldung",
  "HrAttachment": "Anhang",
  "HrDropFile": "Datei hierher ziehen oder",
  "HrBrowse": "auswählen",
  "HrFileTypes": "PDF, JPG oder PNG · bis 10 MB",
  "HrFitNoteRequired": "Krankmeldung bei Abwesenheit über 7 Tage erforderlich",
  "HrDaysShort": "Tage",
  "HrEndBeforeStart": "Ende liegt vor dem Beginn",
  "HrOverBalance": "Nicht genug Resturlaub für diesen Antrag",
  "HrWorkingDaysN_one": "{{count}} Arbeitstag",
  "HrWorkingDaysN_other": "{{count}} Arbeitstage",
  "HrSendRequest": "Antrag senden",
  "HrLeftAfterRequest": "{{left}} von {{total}} {{unit}} übrig"
}
